import { z } from 'zod';
import { sumQuantities } from '../../utils/sum-quantities.js';
import { transferOrderQuantitySchema } from './item-quantity.js';
import { lowercasedRequiredUuidString } from './lowercased-required-uuid-string.js';
import { MAX_TRANSFER_ORDER_PICK_LOTS_PER_REQUEST } from './max-transfer-order-pick-lots-per-request.js';
import { pickTransferOrderLotInputSchema } from './pick-lot-input.js';
const lotsMatchQuantity = (quantity, lotQuantities) => sumQuantities(lotQuantities) === quantity;
export const pickTransferOrderLineInputSchema = z
    .object({
    transferOrderId: lowercasedRequiredUuidString('Transfer order id is required.', 'Invalid transfer order id.'),
    itemId: lowercasedRequiredUuidString('Line item is required.', 'Invalid line item selection.'),
    quantity: transferOrderQuantitySchema,
    /** Absent means FIFO; present, the picker's own lots, which must add up to `quantity`. */
    lots: z
        .array(pickTransferOrderLotInputSchema)
        .min(1, 'Choose at least one lot.')
        .max(MAX_TRANSFER_ORDER_PICK_LOTS_PER_REQUEST, `Choose at most ${MAX_TRANSFER_ORDER_PICK_LOTS_PER_REQUEST} lots.`)
        .nullish(),
})
    .superRefine((values, context) => {
    if (!values.lots)
        return;
    const tagIds = values.lots.map((lot) => lot.tagId);
    if (new Set(tagIds).size !== tagIds.length) {
        context.addIssue({ code: 'custom', path: ['lots'], message: 'Each lot can be chosen once.' });
        return;
    }
    if (!lotsMatchQuantity(values.quantity, values.lots.map((lot) => lot.quantity))) {
        context.addIssue({
            code: 'custom',
            path: ['lots'],
            message: 'The chosen lots must add up to the quantity.',
        });
    }
});
//# sourceMappingURL=pick-line-input.js.map